import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useCreateEmojis = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation((input) => client.media.createEmojis(input), {
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useCreateEmojis.js.map